import { render, staticRenderFns } from "./TestimonialSlider.vue?vue&type=template&id=3254b3ed"
import script from "./TestimonialSlider.vue?vue&type=script&lang=js"
export * from "./TestimonialSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionsVideo: require('/srv/app/components/sections/Video.vue').default,Button: require('/srv/app/components/button/Button.vue').default,TabBottom: require('/srv/app/components/tab/TabBottom.vue').default})
